import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";
import { IMAGES } from "../data";

const QUOTES = [
  {
    quote: "Our chai tapri cups now carry a local gym's branding. They pay us monthly, customers ask about the gym, and my cups cost me nothing. Everyone wins.",
    name: "Ramesh Patel",
    role: "Owner, Kadak Chai Co.",
    avatar: IMAGES.baristaHolding,
  },
  {
    quote: "We printed 10,000 cups placed across 12 chai tapris and cafés in Bengaluru. Footfall from 'saw your cup' mentions beat our entire Instagram budget last quarter.",
    name: "Aisha Kapoor",
    role: "Marketing Lead, Bean There Roasters",
    avatar: IMAGES.hero,
  },
  {
    quote: "The 3D proof blew us away — we saw the exact cup before a single one was printed. Delivery landed in 13 days, two ahead of schedule.",
    name: "Daniel Osei",
    role: "Events Director, Street Sip Society",
    avatar: IMAGES.espresso,
  },
];

export const Testimonials = () => (
  <section id="stories" className="py-24 sm:py-32" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A36] mb-4" data-testid="stories-eyebrow">
          Word on the Street
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#2E1065] leading-tight" data-testid="stories-headline">
          Vendors & brands, <span className="italic text-[#0D9488]">connected.</span>
        </h2>
      </motion.div>

      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {QUOTES.map((q, i) => (
          <motion.figure
            key={q.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`rounded-[2rem] p-7 sm:p-8 flex flex-col border transition-all duration-300 hover:-translate-y-1.5 ${
              i === 1
                ? "bg-[#2E1065] text-[#FAF7F2] border-transparent shadow-xl shadow-[#2E1065]/25 md:-rotate-1"
                : "bg-white text-[#2E1065] border-[#2E1065]/10 hover:shadow-xl hover:shadow-[#2E1065]/10"
            }`}
            data-testid={`testimonial-card-${i}`}
          >
            <div className="flex gap-1 mb-5" data-testid={`testimonial-stars-${i}`}>
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="w-4 h-4 fill-[#FBBF24] text-[#FBBF24]" />
              ))}
            </div>
            <blockquote className={`text-[15px] leading-relaxed flex-1 ${i === 1 ? "text-[#FAF7F2]/85" : "text-[#2E1065]/75"}`}>
              "{q.quote}"
            </blockquote>
            <figcaption className="mt-7 flex items-center gap-3">
              <img src={q.avatar} alt={q.name} className="w-11 h-11 rounded-full object-cover border-2 border-[#FBBF24]" />
              <div>
                <p className="font-display font-bold text-sm flex items-center gap-1.5">
                  {q.name}
                  <BadgeCheck className="w-4 h-4 text-[#0D9488]" />
                </p>
                <p className={`text-xs ${i === 1 ? "text-[#FAF7F2]/60" : "text-[#2E1065]/55"}`}>{q.role}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
